import React from 'react';
import { benefits } from '../data/content';
export function WhatYouGet() {
  const [lead, ...rest] = benefits;
  return <section id="why-aj" className="w-full bg-white py-20 lg:py-28" data-id="element-737" data-mp="101n84o0mrik0">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-738" data-mp="l3l8gowpzh81">
        <div className="max-w-3xl" data-id="element-739" data-mp="l5630ej1b05w">
          <p className="text-sm font-semibold text-sky-600" data-id="element-740" data-mp="q264sd8upgr7">What you get with A&amp;J</p>
          <h2 className="mt-3 font-display text-3xl font-extrabold leading-tight tracking-tight text-navy-800 sm:text-4xl" data-id="element-741" data-mp="1ds0ggrhfoz9v">
            Everything a pool contractor should be, in writing.
          </h2>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-3" data-id="element-742" data-mp="142qs9mppo0r1">
          <article className="flex flex-col justify-between rounded-lg bg-navy-800 p-8 lg:row-span-2" data-id="element-743" data-mp="1404idgfcl95n">
            <div data-id="element-744" data-mp="18yxm4h4u1lsm">
              <lead.icon className="h-10 w-10 text-sky-300" data-id="element-745" data-mp="1wr4pi08z6t1j" />
              <h3 className="mt-7 font-display text-2xl font-bold leading-tight text-white" data-id="element-746" data-mp="1wpjte670j21k">
                {lead.title}
              </h3>
              <p className="mt-4 text-[15px] leading-relaxed text-navy-100" data-id="element-747" data-mp="2vfkg6yw7zslt">{lead.body}</p>
            </div>
            <p className="mt-10 border-t border-navy-600 pt-6 text-sm font-medium text-sky-200" data-id="element-748" data-mp="2qh95yn20jg32">
              An unlicensed contractor is just a gamble wearing a work shirt.
            </p>
          </article>

          {rest.map(benefit => <article key={benefit.title} className="flex h-full flex-col border-t-2 border-navy-100 pt-6" data-id="element-749" data-mp="30e588b1bj5z6">
              <benefit.icon className="h-7 w-7 text-sky-500" data-id="element-750" data-mp="3e4qsa32idlyn" />
              <h3 className="mt-4 font-display text-lg font-bold leading-snug text-navy-800" data-id="element-751" data-mp="3980clgum8sdr">
                {benefit.title}
              </h3>
              <p className="mt-2.5 text-[15px] leading-relaxed text-navy-400" data-id="element-752" data-mp="3o3q0jkjd3fl4">{benefit.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}